export default __webpack_public_path__ + "static/media/a-cross-chain.c65f14eb.svg";